export default {
  route: {
    '密码计算': '密码计算',
    '公告': '公告',
    '公告详情': '公告详情',
    '在线考试': '在线考试',
    '考试记录': '考试记录',
    '证书信息': '证书信息',
    '证书统计': '证书统计',
    '公告管理': '公告管理',
    '培训视频': '培训视频',
    '培训视频管理': '培训视频管理',
    '视频标签管理': '视频标签管理',
    '设备信息': '设备信息',
    '经销商信息': '经销商信息',
    '经销商-设备': '经销商-设备关联',
    '经销商-设备关联': '经销商-设备关联',
    '设备关联': '设备关联',
    '经销商-账号关联': '经销商-账号关联',
    '系统字典': '系统字典',
    '算号记录': '算号记录',
    '账户管理': '账户管理',
    '用户管理': '用户管理',
    '组织管理': '组织管理',
    '角色管理': '角色管理',
    '功能管理': '功能管理',
    '技术文档资料库': '技术文档资料库',
    '员工权限': '员工权限',
    '题库管理': '题库管理',
    '单选题库管理': '单选题库管理',
    '多选题库管理': '多选题库管理',
    '判断题库管理': '判断题库管理',
    '考试培训': '考试培训',
    '系统管理': '系统管理'
  },
  lang: {
    '认证经销商服务平台': '认证经销商服务平台',
    '用户名': '用户名',
    '密码': '密码',
    '登录': '登 录',
    '当前版本': '当前版本',
    '请输入用户名': '请输入用户名',
    '请输入密码': '请输入密码',
    '您的密码强度太低，请尽快修改密码': '您的密码强度太低，请尽快修改密码',
    '修改密码': '修改密码',
    '修改头像': '修改头像',
    '原始密码': '原始密码',
    '新密码': '新密码',
    '可选择': '可选择',
    '确认新密码': '确认新密码',
    '请输入原始密码': '请输入原始密码',
    '两次输入密码不一致': '两次输入密码不一致',
    '请输入新密码': '请输入新密码',
    '请输入不少于6位的密码': '请输入不少于6位的密码',
    '修改成功,请重新登录!': '修改成功,请重新登录!',
    '修改失败!': '修改失败!',
    '请上传正确的图片格式（jpge/jpg/png/gif）': '请上传正确的图片格式（jpge/jpg/png/gif）',
    '图片大小超过1M，请重新选择!': '图片大小超过1M，请重新选择!',
    '图片命名中包含特殊字符，请规正命名再上传!': '图片命名中包含特殊字符，请规正命名再上传!',
    '请选择头像上传': '请选择头像上传',
    '更改头像成功!': '更改头像成功!',
    '更改头像失败!': '更改头像失败!',
    '取消': '取消',
    '确认': '确认',
    '操作': '操作',
    '编辑': '编辑',
    '启用中': '启用中',
    '禁用中': '禁用中',
    '编辑菜单': '编辑菜单',
    '编辑功能': '编辑功能',
    '添加功能': '添加功能',
    '您已修改状态为 --> 禁用': '您已修改状态为 --> 禁用',
    '您已修改状态为 --> 启用': '您已修改状态为 --> 启用',
    '添加成功': '添加成功',
    '添加失败': '添加失败',
    '编辑成功': '编辑成功',
    '编辑失败': '编辑失败',
    '请选择': '请选择',
    '状态': '状态',
    '作废': '作废',
    '功能': '功能',
    '请输入功能名称': '请输入功能名称',
    '功能名': '功能名',
    '请输入功能': '请输入功能',
    '功能url': '功能url',
    '请输入功能url': '请输入功能url',
    '菜单/功能': '菜单/功能',
    '菜单': '菜单',
    '请输入菜单': '请输入菜单',
    '菜单名': '菜单名',
    '请输入菜单名': '请输入菜单名',
    '是否必选': '是否必选',
    '添加菜单': '添加菜单',
    '父级菜单': '父级菜单',
    '是': '是',
    '否': '否',
    '启用': '启用',
    '禁用': '禁用',
    '状态修改失败': '状态修改失败',
    '请选择功能': '请选择功能',
    '查询': '查询',
    '添加': '添加',
    '组织': '组织',
    '父级组织': '父级组织',
    '请输入组织名称': '请输入组织名称',
    '类型': '类型',
    '地址': '地址',
    '添加组织': '添加组织',
    '编辑组织': '编辑组织',
    '名称': '名称',
    '该组织名称已存在': '该组织名称已存在',
    '获取组织根节点列表失败': '获取组织根节点列表失败',
    '请选择组织': '请选择组织',
    '角色': '角色',
    '请输入角色名称': '请输入角色名称',
    '序号': '序号',
    '所属组织': '所属组织',
    '请输入': '请输入',
    '输入用户名': '输入用户名',
    '重置密码': '重置密码',
    '姓名': '姓名',
    '确认密码': '确认密码',
    '邮箱': '邮箱',
    '用户名中不能有空格': '用户名中不能有空格',
    '请输入不少于4位的用户名': '请输入不少于4位的用户名',
    '该用户名已存在': '该用户名已存在',
    '请输入姓名': '请输入姓名',
    '请确认密码': '请确认密码',
    '两次填写的密码不一致': '两次填写的密码不一致',
    '请选择角色': '请选择角色',
    '请输入正确的邮箱地址': '请输入正确的邮箱地址',
    '创建时间': '创建时间',
    '最近修改时间': '最近修改时间',
    '最近登录时间': '最近登录时间',
    '识别码': '识别码',
    '经销商编号': '经销商编号',
    '型号': '型号',
    '修改时间': '修改时间',
    '备注': '备注',
    '批量添加': '批量添加',
    '导出': '导出',
    '退出登录': '退出登录',
    '流水号': '流水号',
    '流水号/注册编号': '流水号/注册编号',
    '请输入流水号/注册编号': '请输入流水号/注册编号',
    '绑定密码': '绑定密码',
    'TG密码': 'Password For【Setup】',
    '探棒设置密码': 'Password For【Probe Setup】',
    '自定义期限密码': 'Password For 【Customised Duration】',
    '永久期限密码': 'Password For 【Permanent Key】',
    '1个月密码': 'Password For 【1 Mth Effective Key】',
    '2个月密码': 'Password For 【2 Mth Effective Key】',
    '3个月密码': 'Password For 【3 Mth Effective Key】',
    '液位仪密码': 'Password For【Liquid Level Meter】',
    '请输入流水号': '请输入流水号',
    '计算失败': '计算失败',
    '登录失败': '登录失败',
    '请先选择类型': '请先选择类型',
    '取消space': '取 消',
    '确定space': '确 定',
    '将文件拖到此处，或': '将文件拖到此处，或',
    '点击上传': '点击上传',
    '只能上传xlsx/xls文件，且不超过500kb': '只能上传xlsx/xls文件，且不超过500kb',
    '模板': '模 板',
    '保存': '保 存',
    '请输入识别码': '请输入识别码',
    '识别码已存在': '识别码已存在',
    '请选择型号': '请选择型号',
    '请选择类型': '请选择类型',
    '确认作废此数据?': '确认作废此数据?',
    '提示': '提示',
    '确定': '确定',
    '作废成功': '作废成功',
    '作废失败': '作废失败',
    '当前限制选择 1 个文件': '当前限制选择 1 个文件',
    '请选择文件': '请选择文件',
    '批量添加成功': '批量添加成功',
    '批量添加失败': '批量添加失败',
    '设备信息批量导入模板': '设备信息批量导入模板',
    '设备信息': '设备信息',
    '关联设备url': '关联设备url',
    '编号': '编号',
    '国家或地区': '国家或地区',
    '联系人': '联系人',
    '电话': '电话',
    '复制': '复制',
    '关闭': '关 闭',
    '请输入名称': '请输入名称',
    '名称已存在': '名称已存在',
    '请输入国家或地区': '请输入国家或地区',
    '获取url失败': '获取url失败',
    '复制成功': '复制成功',
    '经销商信息': '经销商信息',
    '经销商': '经销商',
    '设备识别码': '设备识别码',
    '审核': '审核',
    '审核结果': '审核结果',
    '审核意见': '审核意见',
    '审核备注': '审核备注',
    '请选择经销商': '请选择经销商',
    '请选择审核结果': '请选择审核结果',
    '请输入审核意见': '请输入审核意见',
    '同意': '同意',
    '不同意': '不同意',
    '审核成功': '审核成功',
    '审核失败': '审核失败',
    '有效': '有效',
    '失效': '失效',
    '经销商设备关联': '经销商设备关联',
    '请输入设备识别码': '请输入设备识别码',
    '当前账号未绑定经销商，请联系管理员绑定': '当前账号未绑定经销商，请联系管理员绑定',
    '设备关联': '设备关联',
    '账号': '账号',
    '请选择账号': '请选择账号',
    '经销商账号关联': '经销商账号关联',
    '参数键': '参数键',
    '级参数': '级参数',
    '参数值': '参数值',
    '请输入参数键': '请输入参数键',
    '参数键已存在': '参数键已存在',
    '所有语言参数值 都不能为空': '所有语言参数值 都不能为空',
    '经销商名称': '经销商名称',
    '算号记录': '算号记录',
    '操作人员': '操作人员',
    '序号不能为空': '序号不能为空',
    '序号必须为正数': '序号必须为正数',
    '添加角色': '添加角色',
    '编辑角色': '编辑角色',
    '该角色将被删除, 是否继续?': '该角色将被删除, 是否继续?',
    '添加用户': '添加用户',
    '查询失败': '查询失败',
    '编辑用户': '编辑用户',
    '此操作将重置': '此操作将重置 ',
    '用户密码为': ' 用户密码为',
    ', 是否继续?': ', 是否继续?',
    '重置成功': '重置成功',
    '重置失败': '重置失败',
    '已取消重置': '已取消重置',
    '数据加载中': '数据加载中...',
    '上滑查看更多': '上滑查看更多',
    '没有更多了': '没有更多了',
    '暂无数据': '暂无数据',
    '无权限': ' 无权限',
    '未登录': '未登录',
    '服务器未启动/响应错误': '服务器未启动/响应错误',
    '菜单查询': '菜单查询',
    '设置列': '设置列',
    '地址错误，请检查': '地址错误，请检查',
    '澳科设备认证平台': '澳科设备认证平台',
    '欢迎您使用澳科设备绑定功能': '欢迎您使用澳科设备绑定功能',
    '绑定': '绑 定',
    '获取经销商信息失败': '获取经销商信息失败',
    '未获取到经销商信息，请刷新页面': '未获取到经销商信息，请刷新页面',
    '绑定成功': '绑定成功',
    '绑定失败': '绑定失败',
    '版权所有': '版权所有',
    '青岛澳科仪器有限责任公司': '青岛澳科仪器有限责任公司',
    '关闭其它': '关闭其它',
    '关闭所有': '关闭所有',
    '对应设备已存在': '对应设备已存在',
    '文件': '文件',
    '下载': '下载',
    '液位仪安装验收单': '液位仪安装验收单',
    '测漏安装验收单': '测漏安装验收单',
    '安装工具清单': '安装工具清单',
    '维护': '维护',
    '操作维护指南': '操作维护指南',
    '加油站': '加油站',
    '请输入加油站': '请输入加油站',
    '请先选择经销商': '请先选择经销商',
    '员工': '员工',
    '可计算密码类型': '可计算密码类型',
    '请选择员工': '请选择员工',
    '该员工已添加': '该员工已添加',
    '请选择设备识别码': '请选择设备识别码',
    '请选择可计算密码类型': '请选择可计算密码类型',
    '该经销商未关联用户': '该经销商未关联用户',
    '客服销售人员': '客服销售人员',
    '管理员': '管理员',
    '无此密码类型': '无此密码类型',
    bullshit_info: '请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告',
    return_home: '返回个人中心',
    cant_in: '网管说这个页面你不能进......',
    advice: '为了给您带来更好的使用体验，我们强烈建议您使用极速模式或者Chrome浏览器',
    // 后端
    '暂未登录或token已经过期': '暂未登录或token已经过期'
  },
  fun: {
    '公告': '公告',
    '公告详情': '公告详情',
    '在线考试': '在线考试',
    '考试记录': '考试记录',
    '证书信息': '证书信息',
    '证书统计': '证书统计',
    '公告管理': '公告管理',
    '培训视频': '培训视频',
    '培训视频管理': '培训视频管理',
    '视频标签管理': '视频标签管理',
    '题库管理': '题库管理',
    '单选题库管理': '单选题库管理',
    '多选题库管理': '多选题库管理',
    '判断题库管理': '判断题库管理',
    '用户权限': '用户权限',
    '用户管理': '用户管理',
    '组织管理': '组织管理',
    '角色管理': '角色管理',
    '功能管理': '功能管理',
    '设备信息': '设备信息',
    '经销商信息': '经销商信息',
    '经销商-设备关联': '经销商-设备关联',
    '经销商-账号关联': '经销商-账号关联',
    '系统字典': '系统字典',
    '算号记录': '算号记录',
    '设备关联': '设备关联',
    '密码计算': '密码计算',
    '查询设备全部': '查询设备全部',
    'App': 'App',
    'getInfo': 'getInfo',
    '分页查询设备': '分页查询设备',
    '添加设备信息': '添加设备信息',
    '更新设备信息': '更新设备信息',
    '设备作废': '设备作废',
    '设备识别码判重': '设备识别码判重',
    '分页查询经销商': '分页查询经销商',
    '查询设备经销商全部': '查询设备经销商全部',
    '添加经销商信息': '添加经销商信息',
    '更新经销商信息': '更新经销商信息',
    '经销商信息作废': '经销商信息作废',
    '经销商名称、编号判重': '经销商名称、编号判重',
    '获取当前用户的经销商': '获取当前用户的经销商',
    '分页查询经销商设备关联': '分页查询经销商设备关联',
    '查询经销商设备关联全部': '查询经销商设备关联全部',
    '添加经销商设备关联信息': '添加经销商设备关联信息',
    '更新经销商设备关联信息': '更新经销商设备关联信息',
    '经销商设备关联作废': '经销商设备关联作废',
    '经销商-设备关联查询设备全部': '经销商-设备关联查询设备全部',
    '经销商-设备关联查询设备经销商全部': '经销商-设备关联查询设备经销商全部',
    '经销商-设备关联分页查询经销商设备关联': '经销商-设备关联分页查询经销商设备关联',
    '经销商-设备关联查询经销商设备关联全部': '经销商-设备关联查询经销商设备关联全部',
    '经销商-设备关联添加经销商设备关联信息': '经销商-设备关联添加经销商设备关联信息',
    '经销商-设备关联更新经销商设备关联信息': '经销商-设备关联更新经销商设备关联信息',
    '经销商-设备关联经销商设备关联作废': '经销商-设备关联经销商设备关联作废',
    '经销商设备关联审核': '经销商设备关联审核',
    '分页查询经销商账号关联': '分页查询经销商账号关联',
    '查询经销商账号关联全部': '查询经销商账号关联全部',
    '添加经销商账号关联信息': '添加经销商账号关联信息',
    '更新经销商账号关联信息': '更新经销商账号关联信息',
    '经销商账号关联作废': '经销商账号关联作废',
    '经销商-账号关联获取所有得用户列表': '经销商-账号关联获取所有得用户列表',
    '经销商-账号关联查询设备经销商全部': '经销商-账号关联查询设备经销商全部',
    '右上角添加/修改用户': '右上角添加/修改用户',
    '用户头像-上传本地': '用户头像-上传本地',
    '用户密码修改': '用户密码修改',
    '分页查询组织': '分页查询组织',
    '添加组织': '添加组织',
    '编辑组织': '编辑组织',
    '校验组织是否存在': '校验组织是否存在',
    '查询角色列表': '查询角色列表',
    '删除角色': '删除角色',
    '角色查询所有得权限': '角色查询所有得权限',
    '添加/编辑角色': '添加/编辑角色',
    '组织根节点列表': '组织根节点列表',
    '查询所有得权限': '查询所有得权限',
    '获取所有的菜单': '获取所有的菜单',
    '添加/编辑权限': '添加/编辑权限',
    '获取所有得用户列表': '获取所有得用户列表',
    '添加/修改用户': '添加/修改用户',
    '用户密码重置': '用户密码重置',
    '用户是否存在': '用户是否存在',
    '获取算号': '获取算号',
    '查询全部算号': '查询全部算号',
    '分页查询算号': '分页查询算号',
    '获取关联设备的url': '获取关联设备的url',
    '分页查询系统字典项(树形)': '分页查询系统字典项(树形)',
    '查询所有系统字典项-列表': '查询所有系统字典项-列表',
    '查询系统字典类型': '查询系统字典类型',
    '添加系统字典': '添加系统字典',
    '编辑系统字典': '编辑系统字典',
    '查询下一级系统字典项': '查询下一级系统字典项',
    '校验参数键是否重复': '校验参数键是否重复',
    '设备查询下一级系统字典项': '设备查询下一级系统字典项',
    '批量导入设备信息': '批量导入设备信息',
    '技术文档资料库': '技术文档资料库',
    '技术文档资料库界面': '技术文档资料库界面',
    '更新设备信息admin': '更新设备信息admin',
    '更新设备信息noadmin': '更新设备信息noAdmin',
    '员工权限': '员工权限',
    '查询当前用户组织下可查看角色': '查询当前用户组织下可查看角色',
    '查询算号记录算密码类型': '查询算号记录算密码类型',
    '查询密码计算算密码类型': '查询密码计算算密码类型',
    '查询当前用户角色': '查询当前用户角色',
    '查询员工权限算密码类型': '查询员工权限算密码类型',
    '分页查询员工权限': '分页查询员工权限',
    '查询员工权限全部': '查询员工权限全部',
    '添加员工权限': '添加员工权限',
    '编辑员工权限': '编辑员工权限',
    '校验经销商员工关系是否唯一': '校验经销商员工关系是否唯一',
    '员工权限作废': '员工权限作废',
    '查询指定用户组织下的用户': '查询指定用户组织下的用户',
    '员工权限查询经销商设备关联全部': '员工权限查询经销商设备关联全部',
    '员工权限获取所有得用户列表': '员工权限获取所有得用户列表',
    '员工权限获取当前用户的经销商': '员工权限获取当前用户的经销商',
    '员工权限查询设备经销商全部': '员工权限查询设备经销商全部',
    '员工权限查询经销商账号关联全部': '员工权限查询经销商账号关联全部',
    '用户管理查询当前用户角色': '用户管理查询当前用户角色',
    '获取全部国家和地区': '获取全部国家和地区',
    '公告分页': '公告分页',
    '阅读公告': '阅读公告',
    '公告（详情）': '公告（详情）',
    '公告分页（管理）': '公告分页（管理）',
    '添加公告': '添加公告',
    '编辑公告': '编辑公告',
    '删除公告': '删除公告',
    '新增试卷（考试）': '新增试卷（考试）',
    '试卷内容': '试卷内容',
    '提交试卷': '提交试卷',
    '试卷分页（考试记录）': '试卷分页（考试记录）',
    '用户列表': '用户列表',
    '新增试卷': '新增试卷',
    '证书分页': '证书分页',
    '用户列表（证书）': '用户列表（证书）',
    '培训视频分页': '培训视频分页',
    '培训视频标签分页（视频）': '培训视频标签分页（视频）',
    '培训视频分页（管理）': '培训视频分页（管理）',
    '添加培训视频': '添加培训视频',
    '编辑培训视频': '编辑培训视频',
    '删除培训视频': '删除培训视频',
    '培训视频标签分页（管理）': '培训视频标签分页（管理）',
    '培训视频标签分页': '培训视频标签分页',
    '添加培训视频标签': '添加培训视频标签',
    '编辑培训视频标签': '编辑培训视频标签',
    '删除培训视频标签': '删除培训视频标签',
    '题目列表分页(单选)': '题目列表分页(单选)',
    '新增题目（单选）': '新增题目（单选）',
    '删除题目（单选）': '删除题目（单选）',
    '题目列表分页（多选）': '题目列表分页（多选）',
    '新增题目（多选）': '新增题目（多选）',
    '删除题目（多选）': '删除题目（多选）',
    '题目列表分页（判断）': '题目列表分页（判断）',
    '新增题目（判断）': '新增题目（判断）',
    '删除题目（判断）': '删除题目（判断）',
    '考试培训': '考试培训',
    '系统管理': '系统管理',
    '证书下载': '证书下载',
    '证书下载（考试记录）': '证书下载（考试记录）',
    '证书分页（统计）': '证书分页（统计）',
    '用户列表（统计）': '用户列表（统计）',
    '证书下载（统计）': '证书下载（统计）'
  },
  file: {
    'ATG系列文档': 'ATG Series Documents',

    'ATG操作手册': 'ATG Operation Manual',
    '1-1-3-1-1': "1-1-3-1-1 PD-350+ Networking Tank-eye Operator's Manual V1.5-20250528",
    '1-1-3-1-2': '1-1-3-1-2 PD-350 & PD-350+ Series Console Operator’s Manual 20250520',
    '1-1-3-1-4': '1-1-3-1-4 MC-6 Explosion proof Console Operator’s Manual V2.0',
    '1-1-3-1-5': '1-1-3-1-5 OKet Console Quick Start Guide (20250519)',
    '1-1-3-1-6': '1-1-3-1-6 OKet Guide de Démarrage 20250522',
    '1-1-3-1-7': '1-1-3-1-7 OKet Guía de Inicio Rápido_',

    'ATG改造和安装指南': 'ATG Retrofit And Installation Guide',
    '1-1-4-2-1': '1-1-4-2-1 Automatic Tank Gauge for DEF tanks Installation Guide',
    '1-1-4-2-2': '1-1-4-2-2 Automatic Tank Gauge for LPG tanks Installation Guide',
    '1-1-4-2-3': '1-1-4-2-3 Wired ATG Installation Guide-20251125',
    '1-1-4-2-4': '1-1-4-2-4 Automatic Tank Gauge Installation Guide',
    '1-1-4-2-6': '1-1-4-2-6 Guidance for changing the ATGs grounding method to the single tank shielding layer grounding method',
    '1-1-4-2-7': '1-1-4-2-7 Automatic Tank Gauges Probe Installation Guide for Lubricant',
    '1-1-4-2-8': '1-1-4-2-8 Wireless ATG Installation Guide-20250930',
    '1-1-4-2-9': '1-1-4-2-9 The operation of installing the button cell',
    '1-1-4-2-10': '1-1-4-2-10 Differential pressure level gauge installation and operation guide V1.1-20240829 EN',
    '1-1-4-3-1-1': '1-1-4-3-1-1 Probe length calculation drawing',
    '1-1-4-3-1-2': '1-1-4-3-1-2 Probe length table',
    '1-1-4-3-2-2': '1-1-4-3-2-2 Wired ATG Field Construction and Retrofit Guide',
    '1-1-4-3-2-3': '1-1-4-3-2-3 Wireless ATG Field Construction and Retrofit Guide V1.0 20250415',
    'B——3': "B——3'' B-type riser cover(NPT pipe thread)-Model",
    'N——3': "N——3'' N-type riser cover(G pipe thread)-Model",
    'riser': 'riser cap-2024.11.06',

    'ATG维护指南': 'ATG Maintenance And Troubleshooting',
    '1-1-7-6-1': '1-1-7-6-1 ATG Maintenance Guide',
    '1-1-7-6-2': '1-1-7-6-2 ATG Troubleshooting Guide',
    '1-1-3-5-2': '1-1-3-5-2 ATG Daily Operations and Maintenance  (pdf)',
    '1-1-3-5-3': '1-1-3-5-3 Automatic Tank Gauges Usage Guidelines',
    '1-1-9-1-1': '1-1-9-1-1 OKet PD-350 Series Consoles Troubleshooting Manual（20230807）',

    'LD系列文档': 'LDS Series Documents',

    'LD操作手册：请参考《ATG操作手册》LD改装及安装指南': 'LDS Operation Manual：Please refer to 《ATG Operation Manual》 LDS Retrofit and Installation Guide',

    'LD改造和安装指南': 'LDS Retrofit And Installation Guide',
    '1-2-4-1-1': '1-2-4-1-1 Dispenser Pan Leak Detection Sensor Installation Guide DPLS-1 and DPLS-2C',
    '1-2-4-1-2': '1-2-4-1-2 Double-wall tank gap leak Detection sensor Installation Guide SFLS-2F',
    '1-2-4-1-3': '1-2-4-1-3 Double Wall Pipeline Leak Detection Sensor Installation Guide DLLS-2DA and DLLS-2C ',
    '1-2-4-1-4': '1-2-4-1-4 FRP-Steel Double-wall Tank Leak Detection Sensor Installation Guide SFLS-2DA SFLS-2C ',
    '1-2-4-1-5': '1-2-4-1-5 FRP Double-wall Tank Leak  Detection Sensor Installation Guide HLS-1D',
    '1-2-4-1-6': '1-2-4-1-6 Manhole Well Leak Detection Sensor Installation Guide--CSLS-1',
    '1-2-4-1-7': '1-2-4-1-7 Tank Containment Sump Leak Detection Sensor Installation Guide---FSLS-1',
    '1-2-4-1-9': '1-2-4-1-9 Tank vacuum leak sensor installation guide---vtls-1',

    'LD维护指南': 'LDS Maintenance Guide',
    '1-2-7-1': '1-2-7-1 Leak Sensor Modification Address Operation Instructions',

    'HSSE要求': 'HSSE Requirements',
    'OKet HSSE管理体系要求V202306': 'OKet HSSE Management System Requirements V202306',

    '工具清单和收据模板': 'Tool List And Receipt Template',
    '1-1-4-4-1': '1-1-4-4-1 Installation Tool List for ATG and LDS',
    '1-1-4-4-2': '1-1-4-4-2 Automatic Tank Gauges Installation Acceptance Form ',
    '1-1-5-1-1': "1-1-5-1-1 OKet's ATG Order needs to be clear",
    '1-1-5-1-2': "1-1-5-1-2 OKet's ATG Order needs to be clear（wireless)",
    '1-1-5-2-1': '1-1-5-2-1 ATG 2 inches Packing List & Acceptance Form',
    '1-1-5-2-2': '1-1-5-2-2 ATG 3 inches Packing List & Acceptance Form',
    '1-1-5-2-3': '1-1-5-2-3 ATG(wireless) Packing List & Acceptance Form',
    '1-2-5-1-1': '1-2-5-1-1 CSLS-1 Packing List & Acceptance Form',
    '1-2-5-1-2': '1-2-5-1-2  Packing List & Acceptance Form',
    '1-2-5-1-3': '1-2-5-1-3  DPLS-1 Packing List & Acceptance Form',
    '1-2-5-1-4': '1-2-5-1-4  FSLS-1Packing List & Acceptance Form',
    '1-2-5-2': '1-2-5-2 Leak Detection Integrated Installation Acceptance Form '
  },
  exam: {
    '题目': '题目',
    '题目类别': '题目类别',
    '题目答案': '题目答案',
    '答案解析': '答案解析',
    '暂无解析': '暂无解析',
    '序号': '序号',
    '题目内容': '题目内容',
    '题目配图': '题目配图',
    '暂无': '暂无',
    '操作': '操作',
    '删除': '删除',
    '选项A': '选项A',
    '选项B': '选项B',
    '选项C': '选项C',
    '选项D': '选项D',
    '选项E': '选项E',
    '选项F': '选项F',
    '选项G': '选项G',
    '添加题目': '添加题目',
    '编辑题目': '编辑题目',
    '确认添加': '确认添加',
    '确认编辑': '确认编辑',
    '选项A为必填项': '选项A为必填项',
    '选项B为必填项': '选项B为必填项',
    '选项C为必填项': '选项C为必填项',
    '请选择题目类型': '请选择题目类型',
    '题目内容为必填项': '题目内容为必填项',
    '题目答案为必填项': '题目答案为必填项',
    'ATG安装': 'ATG安装',
    'LDS安装': 'LDS安装',
    '保存成功': '保存成功',
    '保存失败': '保存失败',
    '确定删除该题目吗': '确定删除该题目吗',
    '删除成功': '删除成功',
    '删除失败': '删除失败',
    '正确': '正确',
    '错误': '错误',
    '组织员工': '组织员工',
    '员工': '员工',
    '证书类别': '证书类别',
    '证书下载': '证书下载',
    '员工列表查询失败': '员工列表查询失败',
    '资质证书': '资质证书',
    '证书有效期': '证书有效期',
    '试卷类别': '试卷类别',
    '考试结果': '考试结果',
    '再次考试': '再次考试',
    '合格': '合格',
    '不合格': '不合格',
    '生成试卷失败': '生成试卷失败',
    '考试开始时间': '考试开始时间',
    '考试结束时间': '考试结束时间',
    '考试进行中': '考试进行中',
    '技能类别': '技能类别',
    '标签中文名称': '标签中文名称',
    '标签英文名称': '标签英文名称',
    '标签西班牙名称': '标签西班牙名称',
    '标签法语名称': '标签西班牙名称',
    '请选择技能类别': '请选择技能类别',
    '请输入标签中文名称': '请输入标签中文名称',
    '请输入标签英文名称': '请输入标签英文名称',
    '请输入标签西班牙名称': '请输入标签西班牙名称',
    '请输入标签法语名称': '请输入标签法语名称',
    '返回': '返回',
    '公告标题': '公告标题',
    '公告内容': '公告内容',
    '公告标题(中文)': '公告标题(中文)',
    '公告内容(中文)': '公告内容(中文)',
    '公告标题(英文)': '公告标题(英文)',
    '公告内容(英文)': '公告内容(英文)',
    '公告标题(西班牙)': '公告标题(西班牙)',
    '公告内容(西班牙)': '公告内容(西班牙)',
    '公告标题(法语)': '公告标题(法语)',
    '公告内容(法语)': '公告内容(法语)',
    '请输入公告标题(中文)': '请输入公告标题(中文)',
    '请输入公告内容(中文)': '请输入公告内容(中文)',
    '请输入公告标题(英文)': '请输入公告标题(英文)',
    '请输入公告内容(英文)': '请输入公告内容(英文)',
    '请输入公告标题(西班牙)': '请输入公告标题(西班牙)',
    '请输入公告内容(西班牙)': '请输入公告内容(西班牙)',
    '请输入公告标题(法语)': '请输入公告标题(法语)',
    '请输入公告内容(法语)': '请输入公告内容(法语)',
    '发布时间': '发布时间',
    '已读': '已读',
    '未读': '未读',
    '记录阅读状态失败': '记录阅读状态失败',
    'ATG安装技师考试': 'ATG安装技师考试',
    'LDS安装技师考试': 'LDS安装技师考试',
    '参加考试': '参加考试',
    '退出': '退出',
    '答题卡': '答题卡',
    '考试日期': '考试日期',
    '考试时长': '考试时长',
    '分钟': '分钟',
    '单选题': '单选题',
    '分': '分',
    '多选题': '多选题',
    '判断题': '判断题',
    '无': '无',
    '上一题': '上一题',
    '下一题': '下一题',
    '提交试卷': '提交试卷',
    '已完成': '已完成',
    '每题': '每题',
    '加载中': '加载中',
    '获取试卷详情失败': '获取试卷详情失败',
    '交卷时间已到，系统将帮您自动交卷': '交卷时间已到，系统将帮您自动交卷',
    '交卷失败，数据库错误，请重新开始考试': '交卷失败，数据库错误，请重新开始考试',
    '确定要提交试卷吗': '确定要提交试卷吗',
    '尚未完成所有题目，确定要提交试卷吗': '尚未完成所有题目，确定要提交试卷吗',
    '自动计算成绩中': '自动计算成绩中',
    '提交成功': '提交成功',
    '系统将自动提交试卷，请确认是否离开考试': '系统将自动提交试卷，请确认是否离开考试',
    '退出考试，系统已自动提交试卷': '退出考试，系统已自动提交试卷',
    '可到记录页面查看成绩': '可到记录页面查看成绩',
    '试卷详情': '试卷详情',
    '试卷类型': '试卷类型',
    '全部题数': '全部题数',
    '道': '道',
    '试卷总分': '试卷总分',
    '及格标准': '及格标准',
    '题型介绍': '题型介绍',
    '考试说明': '考试说明',
    '开始考试': '开始考试',
    '确定开始考试吗': '确定开始考试吗',
    '请开始作答': '请开始作答',
    '视频类别': '视频类别',
    '视频名称': '视频名称',
    '视频封面': '视频封面',
    '视频文件': '视频文件',
    '视频名称(英文)': '视频名称(英文)',
    '视频封面(英文)': '视频封面(英文)',
    '视频文件(英文)': '视频文件(英文)',
    '视频名称(中文)': '视频名称(中文)',
    '视频封面(中文)': '视频封面(中文)',
    '视频文件(中文)': '视频文件(中文)',
    '视频名称(西班牙)': '视频名称(西班牙)',
    '视频封面(西班牙)': '视频封面(西班牙)',
    '视频文件(西班牙)': '视频文件(西班牙)',
    '视频名称(法语)': '视频名称(法语)',
    '视频封面(法语)': '视频封面(法语)',
    '视频文件(法语)': '视频文件(法语)',
    '请输入视频名称(英文)': '请输入视频名称(英文)',
    '请选择视频类别': '请选择视频类别',
    '全部': '全部',
    '查询视频标签数据失败': '查询视频标签数据失败',
    '图片大小不能超过2MB': '图片大小不能超过2MB',
    '当前限制选择 1 个文件': '当前限制选择 1 个文件',
    '点击下载': '点击下载',
    '题型单选题': '单选题',
    '题型多选题': '多选题',
    '题型判断题': '判断题',
    '题型道': '道',
    '题型每题': '每题',
    '题型分': '分',
    '上传文件只能是mp4格式': '上传文件只能是.mp4格式',
    '请上传视频封面(英文)': '请上传视频封面(英文)',
    '请上传视频文件(英文)': '请上传视频文件(英文)',
    '上传头像图片只能是JPG/JPEG/PNG格式': '上传头像图片只能是JPG/JPEG/PNG格式',
    '下载失败': '下载失败'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js